<template>
  <div class="block">
    <div class="title-container">
      <h3>Opleverwijze</h3>
      <button class="white-pill-s" @click="$emit('goTo')">
        Bewerken
      </button>
    </div>
    <div>
      <p v-if="mediumError" class="error-text pointer" @click="$emit('goTo')">
        U heeft nog geen opleverwijze gekozen, klik hier.
      </p>
      <div v-if="medium.isArchive">
        <span
          v-if="medium.archive.location == ''"
          class="error-text pointer"
          @click="$emit('goTo')"
          >U heeft nog geen archiefnaam gekozen, klik hier.</span
        >
        <p v-if="medium.archive.location == 'new'">
          Als nieuw online archief (hosted by Rijnja)<br />
          Archiefnaam: <span class="bold"> {{ medium.archive.name }}</span>
        </p>

        <p v-if="medium.archive.location == 'folder'">
          Als nieuwe map in<span class="bold">
            {{ medium.archive.parentFolder }}</span
          ><br />
          Mapnaam: <span class="bold"> {{ medium.archive.name }}</span>
          <span
            v-if="archiveError"
            class="error-text pointer"
            @click="$emit('goTo')"
            >U heeft nog geen mapnaam gekozen, klik hier.</span
          >
        </p>
      </div>
      <div v-if="medium.isEmail">
        Via email:
        <span v-if="!emailError">{{ medium.emailAddress }}</span>
        <span v-else class="pointer error-text" @click="$emit('goTo')"
          >U heeft nog geen geldig emailadres ingevoerd, klik hier.</span
        >
      </div>
      <div v-if="medium.isDisk">
        Op schijf (usb of hdd)
      </div>
      <div v-if="medium.isOther">
        Anders, zie opdrachtomschrijving
      </div>
    </div>
  </div>
</template>

<script>
/**
 * confirmationpage Medium component
 *
 * Properties:
 *
 * - medium : orderDetails.medium object
 **/

export default {
  props: ['medium'],
  data() {
    return {
      archiveError: false,
      emailError: false,
      mediumError: false
    }
  },
  methods: {},
  computed: {},
  created() {
    const email = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.medium.emailAddress)

    if (this.medium.isArchive && this.medium.archive.name.length < 1) {
      this.archiveError = true
    }

    if (this.medium.isEmail && !email) {
      this.emailError = true
    }

    if (
      !this.medium.isArchive &&
      !this.medium.isEmail &&
      !this.medium.isDisk &&
      !this.medium.isOther
    ) {
      this.mediumError = true
    }

    if (this.archiveError || this.emailError || this.mediumError) {
      this.$emit('addError', 'mediumError')
    } else {
      this.$emit('removeError', 'mediumError')
    }
  }
}
</script>

<style lang="scss" scoped></style>
